import { RankingRequestBody } from "@/entities/search-ranking/model/types"

export const buildRankingRequestBody = (hospitalRankingGroupId: number): RankingRequestBody => ({
  hospitalRankingGroupId,
})
